import {
    DriscollsAppLayout,
    DriscollsAppHeader,
    DriscollsTranslatedValue,
    DriscollsTypography,
    DriscollsTypographyEnum,
    DriscollsTypographyStyles,
    FaIcons,
    IconSize,
    DriscollsMobileNavigation,
    DriscollsTypographyTranslated
} from '@driscollsinc/style-guide-web2.0';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../images/Logo_Small_Transparent.png';
import styles from './ApplicationLayout.module.scss';
import { NAMESPACE } from '../../i18n';
import { routes, routesName } from '../routes/routes';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPageTitleAction } from '../../dota/actions/actions';
import useCheckUserGroup from '../hooks/useCheckUserGroup';
import BusinessUnit from '../components/businessUnit/businessUnit';

const DriscollsLogo = () => <img src={logo} alt="driscolls-logo" className={styles.bannerLogo} />;
const APP_NAME = 'Quality Maintenance Platform';

const ApplicationLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { isDemeaAdminUser, isOnlyDemeaUser } = useCheckUserGroup();
    const isDemeaAdminUserFlag = isDemeaAdminUser();
    const isOnlyDemeaUserFlag = isOnlyDemeaUser();

    const navigation = [
        {
            title: 'Bypass',
            description: 'Bypass Locations',
            path: routes[routesName.BYPASS].path,
            ModuleIcon: () => <FaIcons.FaArrowsSplitUpAndLeft size={IconSize.SMALL} className={styles.icon} />,
            isEnabled: true
        },
        {
            title: 'Sites Management',
            description: 'Manage the access of QA Managers',
            path: routes[routesName.SITES].path,
            ModuleIcon: () => <FaIcons.FaSitemap size={IconSize.SMALL} className={styles.icon} />,
            isEnabled: false
        },
        {
            title: 'Point Matrix',
            description: 'Manage the Point Matrix',
            path: routes[routesName.POINT_MATRIX].path,
            ModuleIcon: () => <FaIcons.FaClipboardList size={IconSize.SMALL} className={styles.icon} />,
            isEnabled: isDemeaAdminUserFlag
        },
        {
            title: 'User Management',
            description: 'Manage the access of QA Managers',
            path: routes[routesName.USER_MANAGEMENT].path,
            ModuleIcon: () => <FaIcons.FaUser size={IconSize.SMALL} className={styles.icon} />,
            isEnabled: isDemeaAdminUserFlag
        }
    ];

    useEffect(() => {
        dispatch(setPageTitleAction('Quality Management System'));
        if (location.pathname.includes('demea')) {
            import('../demea.scss');
        }
    }, [location]);

    useEffect(() => {
        isDemeaAdminUserFlag ? navigate(routes[routesName.POINT_MATRIX].path) : navigate(routes[routesName.BYPASS].path);
    }, [])

    return (
        <DriscollsAppLayout
            applicationTitle={
                <DriscollsTypographyTranslated
                    className={styles.title}
                    type={DriscollsTypographyEnum.H6}
                    typographyStyle={DriscollsTypographyStyles.SUBTITLE1}
                    nameSpacing={NAMESPACE.COMMON}
                >
                    {APP_NAME}
                </DriscollsTypographyTranslated>
            }
            header={{
                headerClassName: styles.headerContainer,
                drawer: (close: () => void) => {
                    return (
                        <>
                            <DriscollsLogo />
                            <DriscollsMobileNavigation navigationItem={navigation} drawerClose={close} />
                            <DriscollsTypography
                                type={DriscollsTypographyEnum.P}
                                typographyStyle={DriscollsTypographyStyles.SUBTITLE5}
                                className={styles.appVersion}
                            >
                                <DriscollsTranslatedValue value="App Version" nameSpacing={NAMESPACE.COMMON} />[{process.env.REACT_APP_VERSION}]
                            </DriscollsTypography>
                        </>
                    );
                },
                drawerDirection: 'left',
                tools: [
                    <>
                        <DriscollsAppHeader
                            headerClassName={styles.tools}
                            onLogout={() => navigate('/Logout')}
                            drawerIconClassName={styles.hideIcon}
                            tools={!isOnlyDemeaUserFlag ? <BusinessUnit /> : null}
                        />
                    </>
                ],
                leftChildren: [
                    <>
                        <DriscollsLogo />
                    </>
                ]
            }}
            navigation={{
                navigationItem: navigation
            }}
        />
    );
};

export default ApplicationLayout;
